module.exports = __webpack_public_path__ + "static/media/photo-13.04a4b099.png";